// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__1t5sZ","hidden":"styles_hidden__3l-Zs","parent":"styles_parent__2Kkkq"};